import React, { useContext } from 'react';
import { styled } from 'styled-components';
import { Outlet } from 'react-router-dom';
import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import { ScreenContext } from '../components/ScreenProvider';
import { Text } from '@chakra-ui/react';
// import TopButton from '../components/TopButton';

const MainContainer = styled.div`
  box-sizing: border-box;
`;

const MainContentWrapper = styled.div`
&::-webkit-scrollbar {
  width: 10px;
  display: none;
}
&::-webkit-scrollbar-thumb {
  background: #A4A8AD;
  border-radius: 2px;
}
&::-webkit-scrollbar-track {
  background: #e2e4e7;
  width: 15px;
}
  flex: 1;
  width: 100%;
  height: auto;
  background: #121212;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  -ms-overflow-style: none;
  scrollbar-width: none;
  img {
    color-scheme: light only;
  }
`;

const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #121212;
`;

const Root = () => {
  const screen = useContext(ScreenContext);
    return screen.orientation === "landscape" && (screen.angle === 90 || screen.angle === -90) ? 
    (
      <MainWrapper>
        <Text>세로 모드만 지원합니다.</Text>
      </MainWrapper>
    )
    :
    (
      <>
        <MainHeader />
        <MainContentWrapper id={"main"}>
          <Outlet />
          {/* <TopButton /> */}
          <MainFooter />
        </MainContentWrapper>
      </>
    );
};

export default Root;
